import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Button, Tooltip } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import CloseIcon from '@mui/icons-material/Close';
import DataTable from 'components/Table';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import BackupTableIcon from '@mui/icons-material/BackupTable';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 1400,
  width: '100%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 3,
  paddingTop: 5,
};

const ChartModal = ({
  open,
  handleClose,
  modalChartOptions,
  seriesData,
  type,
  title,
  categories,
}) => {
  const [showChart, setShowChart] = useState(true);
  const [chartOptions, setChartOptions] = useState(modalChartOptions);

  const handleToggleDisplay = () => {
    setShowChart((prevShowChart) => !prevShowChart);
  };

  useEffect(() => {
    if (!open) {
      setShowChart(true);
    }
  }, [open]);

  useEffect(() => {
    const yAxisValues = seriesData.flatMap((s) => s.data);
    const yAxisMin = Math.min(...yAxisValues);
    const yAxisMax = Math.max(...yAxisValues);
    const yAxisMinMaxOffset = type === 'bar' ? 0 : 2;

    setChartOptions((prevOptions) => ({
      ...prevOptions,
      yaxis: {
        ...prevOptions.yaxis,
        min: yAxisMin - yAxisMinMaxOffset,
        max: yAxisMax + yAxisMinMaxOffset,
      },
    }));
  }, [seriesData, type]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <div style={{ position: 'absolute', top: '0', right: '0' }}>
          <Tooltip title={showChart ? 'View as Table' : 'View as Chart'}>
            <Button aria-label='Toggle Display' onClick={handleToggleDisplay}>
              {showChart ? <BackupTableIcon /> : <SsidChartIcon />}
            </Button>
          </Tooltip>
          <Button aria-label='Close Chart Details' onClick={handleClose}>
            <CloseIcon />
          </Button>
        </div>
        {showChart ? (
          <ReactApexChart
            height='600px'
            width='100%'
            options={chartOptions}
            series={seriesData}
            type={type}
          />
        ) : (
          <DataTable data={seriesData} title={title} categories={categories} />
        )}
      </Box>
    </Modal>
  );
};

ChartModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  modalChartOptions: PropTypes.object.isRequired,
  seriesData: PropTypes.array.isRequired,
  type: PropTypes.oneOf(['line', 'area', 'bar']),
  title: PropTypes.string,
  categories: PropTypes.any,
};

export default ChartModal;
